export default __webpack_public_path__ + "/dist/images/sellers-map.590e3b87ab8aec295be49611480aac3e.png";